import React from 'react';
import usePermission from '../hooks/usePermission';
import AccessDenied from './AccessDenied';

/**
 * HOC (High Order Component) para proteger componentes basado en permisos
 * @param {React.ComponentType} Component - Componente a proteger
 * @param {string} requiredPermission - Permiso requerido (ej: "buyorder", "notification")
 * @param {string} requiredAction - Acción requerida (ej: "listView", "create", "update", "delete")
 * @param {React.ReactNode} fallback - Componente a mostrar si no tiene permisos (opcional)
 * @returns {React.ComponentType} - Componente envuelto con protección de permisos
 */
const withPermission = (
  Component,
  requiredPermission,
  requiredAction = 'listView',
  FallbackComponent = AccessDenied
) => {
  const WithPermissionComponent = (props) => {
    const { hasPermission } = usePermission();
    
    if (hasPermission(requiredPermission, requiredAction)) {
      return <Component {...props} />;
    }
    
    return <FallbackComponent />;
  };
  
  // Establecer nombre para depuración
  WithPermissionComponent.displayName = `WithPermission(${Component.displayName || Component.name || 'Component'})`;
  
  return WithPermissionComponent;
};

export default withPermission; 